import Sidebar from "../Common/Sidebar";
import { Card } from "primereact/card";

export default function DashboardLandingPage() {
  return (
    <div className="d-flex vh-100 bg-light">
      <Sidebar pagename="dashboard" />

      <div className="flex-grow-1 d-flex flex-column bg-light py-5 px-5 ">
        <div>
          <h2 className="mb-0">Dashboard</h2>
          <p className="text-muted">Welcome back! Here's what's happening with your knowledge base.</p>
        </div>
        <div className="row mb-4">
          {[
            { title: "Total Documents", value: "845", icon: "fa fa-file", change: "+12%", color: "success" },
            { title: "Sales", value: "254", icon: "fa fa-chart-line", change: "+12%", color: "success" },
            { title: "Support", value: "349", icon: "fa fa-life-ring", change: "+36%", color: "success" },
            { title: "Tag 1", value: "242", icon: "fa fa-bookmark", change: "-10%", color: "danger" },
          ].map((item, idx) => (
            <div key={idx} className="col-md-3">
              <Card className="p-0 shadow-sm border mt-3">
                <div className="d-flex justify-content-between align-items-center">
                  <span className="text-muted">{item.title}</span>
                  <i className={`${item.icon} fs-4 text-secondary`}></i>
                </div>
                <h4 className="mt-2">{item.value}</h4>
                <small className={`text-${item.color}`}>{item.change} Vs last month</small>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
